<template>
	<div class="order-page">
		<NavBar
			title="支付结果"
			left-arrow
			@click-left="onClickLeft"
		/>
		<div class="result" v-if="result === 1">
			<Icon name="checked" size="60" color="#07c160"></Icon>
			<p>支付成功</p>
		</div>
		<div class="result" v-if="result === 0">
			<Icon name="clear" size="60" color="red"></Icon>
			<p>支付失败</p>
		</div>
	</div>
</template>

<script>
import { NavBar, Empty, Icon} from 'vant';

export default {
  components: {NavBar, Empty, Icon},
  data() {
    return {
      result: 1
    }
  },
  created () {
    this.result = this.$route.query.result;
  },
  methods: {
    onClickLeft() {
      this.$router.push('/home')
    }
  }
}
</script>

<style lang="less" scoped>
	.result {
		margin: 30px auto;
		text-align: center;
	}
</style>
